import React, { useEffect, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import {
  Container,
  Typography,
  Input,
  Button,
  ErrorDialog,
} from "src/components";
import { useForm } from "react-hook-form";
import { IError } from "src/components/dialog/error";
import * as formValidators from "src/utils/form-validator";
import { localizationStrings } from "./constants";
import { Auth } from "aws-amplify";
import { useRecoilValue } from "recoil";
import { passwordResetEmailState } from "../../recoil";
import LocalText from "src/local";

import MUIButton from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

type Props = {
  onConfirm: () => void;
};

type FormValues = {
  code: string;
  password: string;
  passwordConfirm: string;
};

const Index: React.FC<Props> = (props) => {
  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { code: "", password: "", passwordConfirm: "" },
  });
  const [error, setError] = useState<IError | null>(null);
  const [processed, setProcessed] = useState<boolean>(false);
  const [showProcessedDialog, setShowProcessedDialog] =
    useState<boolean>(false);
  const passowordResetEmail = useRecoilValue<string>(passwordResetEmailState);
  useEffect(() => {
    register("code", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return localizationStrings.inputCodelValidationRequire;
        }
        // TODO: Add code pattern
        return true;
      },
    });
    register("password", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return localizationStrings.inputPasswordValidationRequire;
        }
        // TODO: Add password pattern
        return true;
      },
    });
    register("passwordConfirm", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return localizationStrings.inputPasswordConfirmValidationRequire;
        }
        if (getValues("password") !== value) {
          return LocalText.screens.authPasswordReset.confirmLayout
            .inputPasswordConfirmValidationMismatch;
        }
        // TODO: Add password confirm pattern
        return true;
      },
    });
  }, [register]);
  const onConfirm = async (data: FormValues) => {
    setProcessed(true);
    try {
      await Auth.forgotPasswordSubmit(
        passowordResetEmail,
        data.code,
        data.password
      );
      setProcessed(false);
      setShowProcessedDialog(true);
    } catch (e: any) {
      if (e.code === "CodeMismatchException") {
        const authError = new Error(
          LocalText.screens.authPasswordReset.confirmLayout.errorCodeMismatchException
        );
        console.error(authError);
        setError(authError);
      } else if (e.code === "InvalidParameterException") {
        const authError = new Error(
          LocalText.screens.authPasswordReset.confirmLayout.errorInvalidParameterException
        );
        console.error(authError);
        setError(authError);
      } else {
        console.error(e);
        setError(e as Error);
      }
      setProcessed(false);
    }
  };
  return (
    <Container style={styles.container} loading={processed}>
      <ScrollView>
        <Typography text={localizationStrings.label} variant={"section"} />
        <Input
          placeholder={localizationStrings.inputCodePlaceholder}
          name={"code"}
          control={control}
          error={errors.code?.message}
          keyboardType={"number-pad"}
          autoCapitalize={"none"}
        />
        <Input
          placeholder={localizationStrings.inputPasswordPlaceholder}
          name={"password"}
          control={control}
          error={errors.password?.message}
          secureTextEntry={true}
          autoCapitalize={"none"}
        />
        <Input
          placeholder={localizationStrings.inputPasswordConfirmPlaceholder}
          name={"passwordConfirm"}
          control={control}
          error={errors.passwordConfirm?.message}
          secureTextEntry={true}
          autoCapitalize={"none"}
        />
        <View style={styles.buttonContainer}>
          <Button
            title={localizationStrings.btnConfirm}
            loading={processed}
            onPress={handleSubmit(onConfirm)}
          />
        </View>
      </ScrollView>
      {error ? (
        <ErrorDialog
          error={error}
          visible={true}
          onClose={() => setError(null)}
        />
      ) : null}
      <Dialog
        open={showProcessedDialog}
        onClose={() => {
          setShowProcessedDialog(false);
          props.onConfirm();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {localizationStrings.processedDialogTitle}
        </DialogTitle>
        <DialogActions>
          <MUIButton
            onClick={() => {
              setShowProcessedDialog(false);
              props.onConfirm();
            }}
            autoFocus
          >
            {localizationStrings.processedDialogBtnOK}
          </MUIButton>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {},
  buttonContainer: {
    flexDirection: "column",
    marginTop: 36,
    marginHorizontal: 16,
  },
});

export default Index;
